import { i18nMark } from 'lingui-react';

const messages = {
  title: i18nMark('It looks like you’re lost…'),
  line1: i18nMark('This page either does not exist or you need permission to view it.'),
  line2: i18nMark('Try using the search bar or contacting the person who gave you the link.'),
};

export default messages;



// WEBPACK FOOTER //
// ./components/NotFoundPage/messages.js